<template>
  <div>
    <chanpin v-if="show"></chanpin>
    <ProductDetails v-else></ProductDetails>
  </div>
</template>
<script>
import chanpin from "./chanpin.vue"
import ProductDetails from "./ProductDetails/index.vue"
export default{
  components:{
    chanpin,
    ProductDetails
  },
  watch:{
    '$route.query.id':function(newVal,oldVal){
      if(newVal){
        this.show=false
      }else{
        this.show=true
      }
    }
  },
  data(){
    return{
     show:true
    } 
  },
  mounted(){
    if(this.$route.query.id){
      this.show=false
    }else{
      this.show=true
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/ProductService.vue